(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/poker-react/components/upcoming-events/assets/javascripts/highlighted-card.js') >= 0) return;  svs.modules.push('/modules/poker-react/components/upcoming-events/assets/javascripts/highlighted-card.js');
"use strict";


const formatCurrency = svs.utils.format.Currency;
const _svs$ui = svs.ui,
  Button = _svs$ui.ReactButton,
  RibbonBanner = _svs$ui.ReactRibbon.RibbonBanner;
const useFormattedDateTime = svs.poker_react.components.upcomingEvents.useFormattedDateTime;
const pokerHome = svs.core.urlMapping.get('pokerHome');
const HighlightedCard = _ref => {
  let tournamentId = _ref.tournamentId,
    registrationEndTime = _ref.registrationEndTime,
    name = _ref.name,
    buyIn = _ref.buyIn,
    registrationCount = _ref.registrationCount,
    onRegistrationClick = _ref.onRegistrationClick,
    startTime = _ref.startTime,
    isLateReg = _ref.isLateReg,
    currency = _ref.currency;
  const _useFormattedDateTime = useFormattedDateTime({
      registrationEndTime,
      startTime,
      isLateReg
    }),
    timeLabel = _useFormattedDateTime.timeLabel,
    dateLabel = _useFormattedDateTime.dateLabel;
  const buyInString = currency === 'SEK' ? "".concat(formatCurrency(buyIn), " kr") : "\u20AC".concat(formatCurrency(buyIn));
  return React.createElement("li", {
    "aria-live": "off",
    className: "highlighted-card",
    key: tournamentId
  }, React.createElement(RibbonBanner, {
    className: "poker-ribbon",
    direction: "left",
    offsetTop: 24,
    size: "400"
  }, isLateReg ? "Sen reg ".concat(timeLabel) : "".concat(dateLabel, " ").concat(timeLabel)), React.createElement("div", {
    className: "info-container"
  }, React.createElement("h2", {
    className: "f-content h2"
  }, name), React.createElement("p", {
    className: "f-content p"
  }, "Ink\xF6p ".concat(buyInString), React.createElement("br", null), "".concat(registrationCount, " anm\xE4lda"))), React.createElement(Button, {
    "aria-label": "Anm\xE4lan till ".concat(name),
    className: "btn-poker",
    Component: "a",
    href: "".concat(pokerHome, "/spela"),
    onClick: e => {
      e.preventDefault();
      onRegistrationClick(tournamentId, name);
    }
  }, "Anm\xE4lan"));
};
setGlobal('svs.poker_react.components.upcomingEvents.HighlightedCard', HighlightedCard);

 })(window);